module.exports = __webpack_public_path__ + "static/img/strong_32.38a9fdd0.png";